import script from "./notesMess.vue?vue&type=script&setup=true&lang=js"
export * from "./notesMess.vue?vue&type=script&setup=true&lang=js"

import "./notesMess.vue?vue&type=style&index=0&id=1420467c&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1420467c"]])

export default __exports__